<div mat-dialog class="dialog-backdrop">
    <h1 mat-dialog-title>Select Carrier for Consolidation</h1>
    <div class="modal-contents">

    </div>
    <div class="error-messages">

    </div>
    <mat-dialog-actions>
        <button mat-flat-button>Cancel</button>
        <button mat-flat-button color="primary">Save</button>
    </mat-dialog-actions>
</div>